// Base path prefix not used for locale anymore.
// We generate both non-localized and localized paths per route.
export default '';
